import React from "react";

const headerStyle = () => {
  return {
    color: "#362B73",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "24px",
    margin: 0,
  };
};

export default function CardHeader({ text }) {
  return <h1 style={headerStyle()}>{text}</h1>;
}
